import { render } from "./LiveCounterTallyPage.vue?vue&type=template&id=5b1d5fe9&scoped=true"
import script from "./LiveCounterTallyPage.vue?vue&type=script&lang=js"
export * from "./LiveCounterTallyPage.vue?vue&type=script&lang=js"

import "./LiveCounterTallyPage.vue?vue&type=style&index=0&id=5b1d5fe9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1d5fe9"]])

export default __exports__